import classNames from 'classnames';
import React, {useEffect} from 'react';

import ClassroomInvitation from './ClassroomInvitation';
import {LoadingSpinner} from '@albert-io/atomic';
import useClassroomInvitations from './hooks/useClassroomInvitations';

interface Props extends PropsWithClassNameOptional {
  classroomId: string | undefined;
}

export default function ClassroomInvitations({className, classroomId}: Props) {
  const {areInvitationsLoading, fetchClassroomInvitations, invitations} = useClassroomInvitations();

  useEffect(() => {
    fetchClassroomInvitations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!areInvitationsLoading && invitations.size === 0) {
    return null;
  }

  return areInvitationsLoading ? (
    <LoadingSpinner bottomMarginLevel={0} size={2} />
  ) : (
    <ul className={classNames(className, 'flex list-none flex-col gap-x1 p-x0')}>
      {invitations
        .map((invitation) => (
          <ClassroomInvitation
            classroomId={classroomId}
            invitation={invitation}
            key={invitation.getId()}
          />
        ))
        .toArray()}
    </ul>
  );
}
